/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "./Route";
import { validateSession } from "Helper/SessionValidator";

const Authmiddleware = () => {
  // State for session validation (cross-subdomain SSO)
  const [isValidating, setIsValidating] = useState(true);
  const [token, setToken] = useState(null);

  // Validate session on mount for cross-subdomain SSO support
  useEffect(() => {
    const checkSession = async () => {
      const storedToken = localStorage.getItem("token");
      
      // Only validate if no local token exists
      if (!storedToken) {
        const { isValid } = await validateSession();
        if (isValid) {
          setToken("authenticated");
        }
      } else {
        setToken(storedToken);
      }
      
      setIsValidating(false);
    };
    
    checkSession();
  }, []);

  // Show loading while validating session (for cross-subdomain SSO)
  if (isValidating) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa"
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      {/* ====== non authenticated routes ====== */}
      {!token &&
        publicRoutes.map((routename, index) => (
          <Route
            key={index}
            path={routename.path}
            element={<routename.component />}
          />
        ))}

      {/* ====== authenticated routes ====== */}
      {token &&
        protectedRoutes.map((routename, index) => (
          <Route
            key={index}
            path={routename.path}
            element={<routename.component />}
          />
        ))}

      {/* ====== redirect rule ====== */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Authmiddleware;